<template>
  <div>
    <h1>Customers</h1>

    <v-overlay v-if="syncing" z-index="998">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <v-data-table
      v-if="customers"
      :headers="headers"
      :items="customers"
      :items-per-page="pageItems"
      class="elevation-1 table datatable"
      :loading="loading"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.name`]="{ item }">
        <v-row>
          <v-col class="ma-0 pb-0"> {{ item.name }} </v-col>
        </v-row>
        <v-row style="text-align: center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="orderInfo"
                style="color: #0099ff; background-color: #99ebff"
              >
                T:{{ item.total_orders }}
              </span>
            </template>
            <span>Total Orders: {{ item.total_orders }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="orderInfo"
                style="color: #00cc00; background-color: #66ff66"
              >
                C:{{ item.completed_orders }}
              </span>
            </template>
            <span>Completed Orders: {{ item.completed_orders }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="orderInfo"
                style="color: #cc3300; background-color: #ff4d4d"
              >
                R:{{ item.returned_orders }}
              </span>
            </template>
            <span>Returned Orders: {{ item.returned_orders }}</span>
          </v-tooltip>
        </v-row>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Reset </v-btn>
      </template>
    </v-data-table>

    <!--SNACKBAR FOR ERRORS-->
    <v-snackbar v-model="snackbar">
      {{ snackBarText }}

      <template>
        <v-btn color="secondary" text @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
    
    <script>
import axios from "axios";
import { BASE_URL } from "./baseUrl";
/* eslint-disable */
export default {
  name: "CustomerView",
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Number", value: "phone", filterable: false },
        { text: "Email", value: "email", filterable: false },
        { text: "Address", value: "address", filterable: false },
        { text: "City", value: "city", filterable: false },
      ],
      totalCustomers: 0,
      customers: null,
      pageItems: 10,
      page: 1,
      loading: true,
      customer: null,
      syncing: false,
      searchTerm: null,
      snackbar: false,
      snackBarText: "",
    };
  },
  mounted() {
    let options = {
      headers: {
        "Access-Control-Allow-Headers":
          "X-Custom-Header, Access-Control-Request-Headers",
          "x-access-token": localStorage.getItem("token"),
        //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
      },
    };
    this.syncing = true;
    var url = BASE_URL + `customers/`;
    axios
      .get(url, options)
      .then((response) => {
        console.log(response);
        this.customers = response.data.customers;
        this.totalCustomers = response.data.totalCount;
        this.loading = false;
        this.syncing = false;
      })
      .catch((error) => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    getAllCustomers() {
      this.syncing = true;
      let options = {
        headers: {
          "Access-Control-Allow-Headers":
            "X-Custom-Header, Access-Control-Request-Headers",
            "x-access-token": localStorage.getItem("token"),
          //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
        },
      };
      var url = BASE_URL + `customers/`;
      axios
        .get(url, options)
        .then((response) => {
          console.log(response);
          this.customers = response.data.customers;
          this.totalCustomers = response.data.totalCount;
          this.loading = false;
          this.syncing = false;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
  
  <style scoped>
.name {
  margin-top: 3%;
  margin-left: 1%;
}

.costPrice {
  margin: 0;
  padding-top: 0;
}

.syncButton {
  margin-top: 2%;
  float: right;
}

.search {
  margin: 2%;
}
.buttonStyle {
  margin-top: -2%;
  float: right;
}
.datatable {
  margin-top: 3%;
}

.orderInfo {
  font-size: 80%;
  margin: 2%;
  margin-bottom: 10%;
  padding: 2%;
  text-align: center !important;
  align-items: center !important;
  border-radius: 20%;
}
</style>